import { toast } from "react-toastify";

import store from "../../redux/reduxStore";

import { removeAuth } from "../../redux/actions/auth/authActions";

function handleUnauthorizedError(error) {
  store.dispatch(removeAuth({ message: error.message }));
  toast.error(error.message);
}

function handleServerError(err) {
  toast.error(err.message);
}

function handleCommonApiError(err) {
  if (window.location.pathname.includes("dashboard")) {
    window.location.replace("/");
  }
  toast.error(err.message);
}

export default handleServerError;

export { handleUnauthorizedError, handleCommonApiError };
